export default {
    yellow: '#FEC667',
    lightBlue: '#8AC5FF',
    rose: '#F1CBD4',
    lile: '#AC9DC8',
    green: '#218D4F',
    red: '#FE5E3E',
    new: '#F1CBD4',
    black: '#000000',
    headerHeight: '80px',
    footerHeight: '140px',
    complementary: '#2F06FC',
    plexMono: 'IBM Plex Mono',
    aprecuPro: 'Apercu Pro',
    apercuProBold: 'Apercu Pro',
    fraklinGothicDC: 'ITC Franklin Gothic Std',
}